module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Align-justify-4971a4ffcab2c00eafb7e3439beeaf54.svg";